import React from 'react';
import { BooleanInput, List, Edit, Datagrid, SimpleForm, TextField, EditButton, ReferenceField } from 'react-admin';

export const TaskList = (props) => (
  <List {...props}>
    <Datagrid>
      <TextField source="task_type" />
      <ReferenceField label="Auth" source="auth_id" reference="auth" linkType="show">
        <TextField label="Uuid" source="uuid" />
      </ReferenceField>
      <TextField source="data" />
      <ReferenceField label="Site" source="user_id" reference="user">
        <TextField label="Domain" source="domain" />
      </ReferenceField>
      <TextField source="updated_at" />
      <EditButton />
    </Datagrid>
  </List>
);

export const TaskEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <TextField source="task_type" />
      <ReferenceField label="Auth" source="auth_id" reference="auth" linkType="show">
        <TextField label="Uuid" source="uuid" />
      </ReferenceField>
      <TextField source="data" />
      <ReferenceField label="Site" source="user_id" reference="user">
        <TextField label="Domain" source="domain" />
      </ReferenceField>
      <TextField source="created_at" />
      <TextField source="updated_at" />
      <BooleanInput label="Complete?" source="complete"/>
    </SimpleForm>
  </Edit>
);


// WEBPACK FOOTER //
// ./resources/assets/js/task.js